class SizeGuide extends HTMLElement {
  constructor () {
    super()

    this.setupListeners()
  }

  setupListeners () {
    this.handleTrigger = this.handleTrigger.bind(this)
    document.addEventListener('click', this.handleTrigger)
  }

  async handleTrigger (event) {
    const trigger = event.target.closest(
      '[data-size-guide-external-el="trigger"]',
    )

    if (!trigger) return

    try {
      const fetchUrl = `${trigger.dataset.productUrl}?section_id=size-guide`;

      const response = await fetch(fetchUrl)
      const html = await response.text()

      const newDOM = new DOMParser().parseFromString(html, 'text/html')
      const bodyContent = newDOM.querySelector('.drw-SizeGuide')

      const wrapper = document.querySelector('[data-size-guide-el="body"]')
      wrapper.innerHTML = bodyContent.outerHTML

      this.initDrawer()

      window.drawers.activeDrawerKey = 'size-guide'
    } catch (error) {
      window.drawers.activeDrawerKey = ''
    }
  }

  initDrawer () {
    this.initTabs()
    this.initMeasurementsToggle()
    this.initMarketSelector()
  }

  initTabs () {
    const tabEls = this.querySelectorAll('[data-size-guide-el="tab"]')

    tabEls.forEach((tab) => {
      tab.addEventListener('click', this.handleTabClick.bind(this))
      tab.addEventListener('keydown', this.handleTabKeydown.bind(this))
    })
  }

  handleTabClick (event) {
    const tab = event.target.closest('[data-size-guide-el="tab"]')

    if (!tab) return

    this.activateTab(tab)
  }

  /**
   * Implements the ARIA authoring practices roving tabindex pattern for tabs.
   * Arrow keys move focus between tabs; Home/End jump to first/last.
   */
  handleTabKeydown (event) {
    const currentTab = event.target.closest('[data-size-guide-el="tab"]')

    if (!currentTab) return

    const tabList = currentTab.closest('[data-size-guide-el="tab-list"]')
    const tabEls = Array.from(
      (tabList || document).querySelectorAll('[data-size-guide-el="tab"]'),
    )
    const currentIndex = tabEls.indexOf(currentTab)

    let targetIndex = null

    switch (event.key) {
      case 'ArrowRight':
        targetIndex = (currentIndex + 1) % tabEls.length
        break
      case 'ArrowLeft':
        targetIndex = (currentIndex - 1 + tabEls.length) % tabEls.length
        break
      case 'Home':
        targetIndex = 0
        break
      case 'End':
        targetIndex = tabEls.length - 1
        break
      default:
        return
    }

    event.preventDefault()
    this.activateTab(tabEls[targetIndex])
    tabEls[targetIndex].focus()
  }

  activateTab (activeTab) {
    const targetKey = activeTab.dataset.tabTarget

    const container = activeTab.closest('[data-size-guide-el="body"]') || document

    const tabEls = container.querySelectorAll('[data-size-guide-el="tab"]')
    const panelEls = container.querySelectorAll('[data-size-guide-el="tab-panel"]')

    tabEls.forEach((tab) => {
      const isActive = tab === activeTab

      tab.setAttribute('aria-selected', String(isActive))
      tab.setAttribute('tabindex', isActive ? '0' : '-1')
      tab.classList.toggle('drw-SizeGuide_Tab-active', isActive)
    })

    panelEls.forEach((panel) => {
      const isActive = panel.dataset.tabPanel === targetKey

      if (isActive) {
        panel.removeAttribute('hidden')
        panel.classList.add('drw-SizeGuide_TabPanel-active')
      } else {
        panel.setAttribute('hidden', '')
        panel.classList.remove('drw-SizeGuide_TabPanel-active')
      }
    })
  }

  initMeasurementsToggle () {
    const unitToggleInput = this.querySelector('[data-size-guide-el="unit-toggle-input"]')

    if (!unitToggleInput) return

    unitToggleInput.addEventListener('change', event =>{
      const unit = event.target.checked ? 'in' : 'cm'
      this.setActiveUnit(unit)
    })
  }

  setActiveUnit (unit) {
    const table = this.querySelector('[data-size-guide-el="size-table"]')
    table.setAttribute('data-active-unit', unit)
  }

  initMarketSelector () {
    const marketSelect = this.querySelector('[data-size-guide-el="market-select"]')

    if (!marketSelect) return

    marketSelect.addEventListener('change', event => {
      this.setActiveMarket(event.target.value)
    })

    this.setActiveMarket(marketSelect.value)
  }

  setActiveMarket (market) {
    const table = this.querySelector('[data-size-guide-el="size-table"]')

    if (!table) return

    table.setAttribute('data-active-market', market)

    table.querySelectorAll('[data-market-col]').forEach((el) => {
      el.hidden = el.dataset.marketCol !== market
    })
  }
}

if (!customElements.get('size-guide')) {
  customElements.define('size-guide', SizeGuide)
}
